<mat-grid-list cols="2" rowHeight="2:1">
    <mat-grid-tile *ngIf="permissionService.SafetyPointLesen">
        <mat-card appearance="outlined" routerLink="/SafetypointSuche">
            <div>
                <mat-icon>category</mat-icon>
                <mat-icon>search</mat-icon>
            </div>
            {{language.safetypointsuche | translationPipe}}
        </mat-card>
    </mat-grid-tile>

    <!-- <mat-grid-tile *ngIf="permissionService.SafetyPointSchreiben">
        <mat-card appearance="outlined" routerLink="/SafetypointErfassen">
            <div>
                <mat-icon>category</mat-icon>
                <mat-icon>search</mat-icon>
            </div>
            {{language.safetypointerstellen | translationPipe}}
        </mat-card>
    </mat-grid-tile> -->

    <!-- <mat-grid-tile *ngIf="userService.bestellungBearbeiten && userService.appBestellposten">
        <mat-card appearance="outlined" routerLink="/bestellpositionErfassen">
            <div>
                <mat-icon>calendar_month</mat-icon>
                <mat-icon>format_list_numbered</mat-icon>
            </div>
            {{language.Bestellposten | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="licenseService.ModulBestandsfuehrung && userService.appBestelleingang">
        <mat-card appearance="outlined" (click)="navigateToDelivery()">
            <div>
                <mat-icon>calendar_month</mat-icon>
                <mat-icon>rule</mat-icon>
            </div>
            {{language.Bestelleingang | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="licenseService.ModulBestandsfuehrung && userService.appEinlagerung">
        <mat-card appearance="outlined" routerLink="/einlagerung">
            <div>
                <mat-icon>arrow_forward</mat-icon>
                <mat-icon>warehouse</mat-icon>
            </div>
            {{language.Einlagerung | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="licenseService.ModulBestandsfuehrung && userService.appEntnahme">
        <mat-card appearance="outlined" routerLink="/lagerentnahme">
            <div>
                <mat-icon>arrow_back</mat-icon>
                <mat-icon>warehouse</mat-icon>
            </div>
            {{language.Lagerentnahme | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="environment.wasteBooking && licenseService.ModulBestandsfuehrung && userService.appAusschuss">
        <mat-card appearance="outlined" routerLink="/ausschuss">
            <div>
                <mat-icon>arrow_forward</mat-icon>
                <mat-icon>delete</mat-icon>
            </div>
            {{language.Ausschuss | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile
        *ngIf="environment.repairBooking && licenseService.ModulBestandsfuehrung && userService.appReparatur">
        <mat-card appearance="outlined" routerLink="/reparatur">
            <div>
                <mat-icon>category</mat-icon>
                <mat-icon>build</mat-icon>
            </div>
            {{language.Reparatur | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile
        *ngIf="environment.articleCommodityBooking && licenseService.ModulBestandsfuehrung && licenseService.ModulGebrauchsgueterverwaltung && userService.appArtikelbuchungGebrauchsgut">
        <mat-card appearance="outlined" routerLink="/artikelBuchungGebrauchsgut">
            <div>
                <mat-icon>arrow_forward</mat-icon>
                <mat-icon>home_repair_service</mat-icon>
            </div>
            {{language.ArtikelBuchungGebrauchsgut | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile
        *ngIf="licenseService.ModulBestandsfuehrung && settings?.ErweiterteLagerVerwaltung && userService.appUmlagerung">
        <mat-card appearance="outlined" routerLink="/umlagerung">
            <div>
                <mat-icon>sync_alt</mat-icon>
                <mat-icon>warehouse</mat-icon>
            </div>
            {{language.Umlagerung | translationPipe}}
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="userService.appInventur">
        <mat-card appearance="outlined" routerLink="/inventur">
            <div>
                <mat-icon>edit_note</mat-icon>
                <mat-icon>warehouse</mat-icon>
            </div>
            {{language.Inventur | translationPipe}}
        </mat-card>
    </mat-grid-tile> -->
</mat-grid-list>